import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeroSection = styled.section`
  width: 100%;
  min-height: 100dvh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: none;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.0) 10%);
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;
export const HeroImage = styled.img`
  width: 100%;
  max-height: 400px;
  object-fit: cover;
  display: block;
`;
export const HeaderSection = styled("header")`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  backdrop-filter: blur(2px);
  padding: 1rem 0.5rem;
  color: #fff;
  font-weight: normal;
    font-family: "inter", sans-serif;
    letter-spacing: 0px;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }

  a, span, h5, button {
    color: #fff !important;
    font-weight: normal !important;
    text-shadow: 0 2px 8px rgba(0,0,0,0.3);
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  padding: 0.5rem 1rem;
  align-items: center;
  img {
    filter: brightness(0) invert(1);
    max-width: 320px;
    max-height: 80px;
    width: 200%;
    height: auto;
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 1000px) {
    display: block;
  }

  display: none;

  svg {
    fill: #fff;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 1000px) {
    display: none;
  }

  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 400;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #393939;
  transition: color 0.2s ease-in;
  margin: 0.1rem 1.2rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 400;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(57, 57, 57, 0.25);
    text-underline-position: under;
    text-decoration: underline rgb(255,255,255,1);
    text-decoration-thickness: 2px;
    text-decoration-style: solid;
  }
`;

export const BookingButton = styled("a")`
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid #fff;
  color: #fff !important;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease-in-out;
  backdrop-filter: blur(10px);
  text-shadow: 0 2px 8px rgba(0,0,0,0.3);
  margin: 0 0.5rem;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    color: #fff !important;
    text-decoration: none;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  }

  @media only screen and (max-width: 1000px) {
    display: none;
  }
`;

export const MobileBookingButton = styled("a")`
  background: #18b486;
  border: 2px solid #18b486;
  color: #fff !important;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease-in-out;
  margin: 1rem 2rem;
  display: block;
  text-align: center;

  &:hover {
    background: #15a076;
    border-color: #15a076;
    color: #fff !important;
    text-decoration: none;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  }
`;
